// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".86bc80d873a05388408317b765ab832c6589221b.chunk.js";
};